import React, { useState, useEffect } from "react";
import {
    Grid,
    CircularProgress,
    Typography,
    Button,
    Tabs,
    Tab,
    TextField,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import moment from "moment";


// styles
import useStyles from "./styles";

// logo
import logo from "./logo.png";

// context
import { useUserDispatch, loginUser } from "../../context/UserContext";

function Login(props) {
    var classes = useStyles();

    // global
    var userDispatch = useUserDispatch();

    // local
    var [isLoading, setIsLoading] = useState(false);
    var [error, setError] = useState(null);
    var [activeTabId, setActiveTabId] = useState(0);
    var [nameValue, setNameValue] = useState("");
    var [loginValue, setLoginValue] = useState("");
    var [passwordValue, setPasswordValue] = useState("");

    const [useSalute, setSalute] = useState("");
    useEffect(() => {
        let currentTime = moment().format('H');
        
        if(currentTime < 5){
            setSalute("Gute Nacht");
        } else if(currentTime < 11){
            setSalute("Guten Morgen");
        } else if(currentTime < 18){
            setSalute("Guten Tag");
        } else if(currentTime < 20){
            setSalute("Guten Abend");
        } else{
            setSalute("Gute Nacht");
        }
    }, []);

    return (
        <Grid container className={classes.container}>
            <div className={classes.logotypeContainer}>
                <img src={logo} alt="logo" className={classes.logotypeImage} />
                <Typography className={classes.logotypeText}>
                    Personalmatrix
                </Typography>
            </div>
            <div className={classes.formContainer}>
                <div className={classes.form}>
                    <Tabs
                        value={activeTabId}
                        onChange={(e, id) => setActiveTabId(id)}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab label="Anmeldung" classes={{ root: classes.tab }} />
                    </Tabs>
                    {activeTabId === 0 && (
                        <React.Fragment>
                            <Typography
                                variant="h1"
                                className={classes.greeting}
                            >
                                {useSalute}
                            </Typography>
                            
                            
                            
                            <TextField
                                id="email"
                                InputProps={{
                                    classes: {
                                        underline: classes.textFieldUnderline,
                                        input: classes.textField,
                                    },
                                }}
                                value={loginValue}
                                onChange={(e) => setLoginValue(e.target.value)}
                                margin="normal"
                                placeholder="Benutzername"
                                type="text"
                                fullWidth
                            />
                            <TextField
                                id="password"
                                InputProps={{
                                    classes: {
                                        underline: classes.textFieldUnderline,
                                        input: classes.textField,
                                    },
                                }}
                                value={passwordValue}
                                onChange={(e) =>
                                    setPasswordValue(e.target.value)
                                }
                                margin="normal"
                                placeholder="Passwort"
                                type="password"
                                fullWidth
                            />
                            <div className={classes.formButtons}>
                                {isLoading ? (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                ) : (
                                    <Button
                                        disabled={
                                            loginValue.length === 0 ||
                                            passwordValue.length === 0
                                        }
                                        onClick={() =>
                                            loginUser(
                                                userDispatch,
                                                loginValue,
                                                passwordValue,
                                                props.history,
                                                setIsLoading,
                                                setError
                                            )
                                        }
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                    >
                                        Anmeldung
                                    </Button>
                                )}
                                
                            </div>
                        </React.Fragment>
                    )}
                    
                </div>
                <Typography color="primary" className={classes.copyright}>
                    SHS Consulting
                </Typography>
            </div>
        </Grid>
    );
}

export default withRouter(Login);
